import { METHODS } from 'Jsx/CheckoutV4/common/constants';
import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';

const isEbanxCard = (paymentMethodTitle: string) =>
  paymentMethodTitle === METHODS.EBANX_CARD ||
  paymentMethodTitle === METHODS.EBANX_CARD_AR;

export const isCardPaymentMethod = (methodTitle: string) =>
  methodTitle === METHODS.STRIPE ||
  methodTitle === METHODS.STRIPE_MEXICO ||
  methodTitle === METHODS.CONEKTA_CARD ||
  methodTitle === METHODS.EBANX_CARD ||
  methodTitle === METHODS.EBANX_CARD_AR ||
  methodTitle === METHODS.PAYU_PERU ||
  methodTitle === METHODS.DLOCAL_PERU ||
  methodTitle === METHODS.DLOCAL_MEXICO ||
  methodTitle === METHODS.DLOCAL_AR ||
  methodTitle === METHODS.DLOCAL_COLOMBIA ||
  methodTitle === METHODS.DLOCAL_CHILE ||
  methodTitle === METHODS.MERCADOPAGO_CARD_MEXICO;

export const getStepsForMethod = (
  paymentMethodTitle: string | undefined,
  isMarketProduct: boolean,
  isGuestCheckout: boolean,
) => {
  let steps: any[] = [];

  if (isMarketProduct) {
    steps = [
      {
        label: I18N_STRINGS.PAYMENT_STEP,
        status: 'current',
      },
      {
        label: I18N_STRINGS.DELIVERY_STEP,
        status: 'disabled',
      },
      isGuestCheckout
        ? {
            label: I18N_STRINGS.ACTIVATION,
            status: 'disabled',
          }
        : null,
      !isGuestCheckout
        ? {
            label: I18N_STRINGS.LAST_STEP,
            status: 'disabled',
          }
        : null,
    ];
  } else if (paymentMethodTitle && isEbanxCard(paymentMethodTitle)) {
    steps = [
      {
        label: I18N_STRINGS.PERSONAL_INFO,
        status: 'current',
      },
      {
        label: I18N_STRINGS.CARD_INFO,
        status: 'disabled',
      },
      isGuestCheckout
        ? {
            label: I18N_STRINGS.ACTIVATION,
            status: 'disabled',
          }
        : null,
      !isGuestCheckout
        ? {
            label: I18N_STRINGS.LAST_STEP,
            status: 'disabled',
          }
        : null,
    ];
  } else {
    steps = [
      {
        label: I18N_STRINGS.PAYMENT_STEP,
        status: 'current',
      },
      isGuestCheckout
        ? {
            label: I18N_STRINGS.ACTIVATION,
            status: 'disabled',
          }
        : null,
      !isGuestCheckout
        ? {
            label: I18N_STRINGS.LAST_STEP,
            status: 'disabled',
          }
        : null,
    ];
  }

  return steps.filter(el => el !== null);
};
